import DOMPurify from 'dompurify';

/**
 * Converts plain text to HTML with line breaks
 * Mimics Ember's simple-format helper
 * 
 * @param text - The text to format
 * @param allowHtml - Whether to allow HTML (will be sanitized)
 * @param _host - Optional host for link processing (unused in current implementation)
 * @returns Formatted and sanitized HTML string
 */
export function simpleFormat(
  text: string | undefined | null,
  allowHtml = false,
  _host?: string
): string {
  if (!text) return '';

  let formattedText = String(text);

  if (allowHtml) {
    // Sanitize HTML but preserve safe tags and links
    formattedText = DOMPurify.sanitize(formattedText, {
      ALLOWED_TAGS: [
        'a',
        'b',
        'strong',
        'i',
        'em',
        'u',
        'br',
        'p',
        'span',
        'div',
        'ul',
        'ol',
        'li',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
      ],
      ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
    });
  } else {
    // Escape HTML entities
    formattedText = formattedText
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;');
  }

  // Convert line breaks to <br> tags
  formattedText = formattedText
    .replace(/(\r\n|\n|\r)/gm, '<br>')
    .replace(/<\/p>(\w|\s|\r\n|\n|\r)*<br>/gm, '</p>');

  return formattedText;
}

